import { useCallback, useEffect, useMemo, useState } from 'react';

import { useMyPurchaseSizeList } from '../queries/useMyPurchaseSizeList';
import { ActualSizeTabName, SIZE_TAB, SizeInfoItem } from '../services/actual-size/types';

export const useSizeComparison = (rawItem: SizeInfoItem | undefined, activeTab: ActualSizeTabName) => {
  const { data: myPurchaseData } = useMyPurchaseSizeList(rawItem?.sizeCategoryId);
  // uniqueKey 기반으로 선택 상태 관리 (동일 상품 중복 구매 시에도 각각 구분 가능)
  const [selectedUniqueKey, setSelectedUniqueKey] = useState<string | null>(null);

  useEffect(() => {
    if (myPurchaseData && myPurchaseData.length > 0 && !selectedUniqueKey) {
      // isSelected(is_comparing)가 true인 항목이 있을 때만 기본 선택
      // 비교 이력이 없으면 아무것도 선택하지 않음 (모든 상품에 "비교하기" 버튼 노출)
      const defaultItem = myPurchaseData.find((item) => item.isSelected);
      if (defaultItem) {
        setSelectedUniqueKey(defaultItem.uniqueKey);
      }
    }
  }, [myPurchaseData, selectedUniqueKey]);

  const sortedMyPurchaseData = useMemo(() => {
    if (!myPurchaseData) return [];
    if (!selectedUniqueKey) return myPurchaseData;

    return [...myPurchaseData].sort((a, b) => {
      if (a.uniqueKey === selectedUniqueKey) return -1;
      if (b.uniqueKey === selectedUniqueKey) return 1;
      return 0;
    });
  }, [myPurchaseData, selectedUniqueKey]);

  const onPurchaseCardClick = useCallback((uniqueKey: string) => {
    setSelectedUniqueKey(uniqueKey);
  }, []);

  const getCompareData = () => {
    if (activeTab === SIZE_TAB.MY_PURCHASE && selectedUniqueKey && myPurchaseData && rawItem) {
      const selectedPurchase = myPurchaseData.find((item) => item.uniqueKey === selectedUniqueKey);
      if (selectedPurchase) {
        const headers = rawItem.headers;
        const compareValues = headers.slice(1).map((colName) => {
          const value = selectedPurchase.sizeInfo[colName];
          return value || '-';
        });

        // 비교 행 데이터 (라벨 포함)
        const compareRow = ['비교상품', ...compareValues.map(String)];

        return {
          compareRow,
          selectedPurchase,
        };
      }
    }
    return null;
  };

  const compareData = getCompareData();

  return {
    myPurchaseData: sortedMyPurchaseData,
    selectedPurchaseId: selectedUniqueKey,
    onPurchaseCardClick,
    compareRow: compareData?.compareRow,
    selectedPurchaseImage: compareData?.selectedPurchase?.imageUrl,
  };
};
